import { render, staticRenderFns } from "./ApproveJobBtn.vue?vue&type=template&id=2045b7fd&scoped=true&"
import script from "./ApproveJobBtn.vue?vue&type=script&lang=js&"
export * from "./ApproveJobBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045b7fd",
  null
  
)

export default component.exports